
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RefinancaBanner',
  props: {
    isCookieVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isBannerVisible: true,
      bannerBottom: 0,
      observer: null as MutationObserver | null,
    };
  },
  watch: {
    isCookieVisible() {
      this.$nextTick(() => this.calculateBottom());
    },
  },
  methods: {
    closeBanner() {
      this.isBannerVisible = false;
    },
    calculateBottom() {
      const cookieEl = document.querySelector('.cookie-consent.active') as HTMLElement;
      if (cookieEl && this.isCookieVisible) {
        this.bannerBottom = cookieEl.offsetHeight;
      } else {
        this.bannerBottom = 0;
      }
    },
  },
  mounted() {
    this.calculateBottom();
    window.addEventListener('resize', this.calculateBottom);

    // Observe cookie consent changes
    this.observer = new MutationObserver(() => {
      this.calculateBottom();
    });
    const cookieEl = document.querySelector('.cookie-consent');
    if (cookieEl) {
      this.observer.observe(cookieEl, { attributes: true, attributeFilter: ['class'] });
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateBottom);
    if (this.observer) {
      this.observer.disconnect();
    }
  },
});
